// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25xW6","footer":"styles_footer__3gCW1","passCodeTooltip":"styles_passCodeTooltip__3siG0"};